import React, {useContext, useEffect} from "react";
import {useNavigate} from "react-router-dom";
import checkListIcon from "../../../assets/images/checklist.jpg";
import {StoreContext} from "../../../store/StoreContext";

const Roles = () => {
  const navigate = useNavigate();
  const {setAppTitle, session} = useContext(StoreContext); // Acceder a `session`

  // Determinar si el usuario tiene perfil 1 (Administrador)
  const isAdmin = session?.profile === 1;
  const isInspector = session?.profile === 2;
  const isSupervisorOnly = session?.profile === 4;


  useEffect(() => {
    setAppTitle("Selección de Rol");
  }, []);

  //console.log(session);
  return (
    <div className="row">
      <div className="col-12">
        <div className="d-flex justify-content-center py-4">
          <img src={checkListIcon} alt="Icon" height="150px" />
        </div>
      </div>

      {isAdmin ? (
        // Si es admin, mostrar ambos botones
        <>
          <div className="col-12 col-md-3 ms-md-auto">
            <button
              type="button"
              className="btn bg-primary text-white btn-lg mb-3 ms-md-auto me-md-4 w-100"
              onClick={() => navigate("Jefatura")}
            >
              Supervisor
            </button>
          </div>
          <div className="col col-md-3 me-md-auto">
            <button
              type="button"
              className="btn bg-primary text-white btn-lg mb-3 me-md-auto ms-md-4 w-100"
              onClick={() => navigate("Inspector")}
            >
              SSO
            </button>
          </div>
        </>
      ) : isSupervisorOnly ? (
        // Si es solo supervisor (profile 4), solo botón Supervisor
        <div className="col-12 d-flex justify-content-center">
          <div className="col-auto">
            <button
              type="button"
              className="btn bg-primary text-white btn-lg mb-3"
              style={{ minWidth: "300px" }}
              onClick={() => navigate("Jefatura")}
            >
              Supervisor
            </button>
          </div>
        </div>
      ) : (
        // Para cualquier otro perfil (ej. perfil 2), solo botón SSO
        <div className="col-12 d-flex justify-content-center">
          <div className="col-auto">
            <button
              type="button"
              className="btn bg-primary text-white btn-lg mb-3"
              style={{ minWidth: "300px" }}
              onClick={() => navigate("Inspector")}
            >
              SSO
            </button>
          </div>
        </div>
      )}
    </div>
  );
};

export default Roles;
